module.exports = __webpack_public_path__ + "static/media/img_female.0108b012.svg";